{
  "panel": {
    "title": "Catatan",
    "newNote_title": "Catatan baru",
    "search_placeholder": "Cari catatan…",
    "search_aria": "Cari catatan",
    "clearSearch_aria": "Bersihkan pencarian",
    "editorPlaceholder": "Apa yang ada di pikiran Anda…",
    "titleInput_placeholder": "Tanpa Judul",
    "untitled": "Tanpa judul",
    "emptyNote": "Catatan kosong",
    "loadingNotes": "Memuat catatan…",
    "noNotesYet": "Belum ada catatan. Ketuk + untuk membuat satu.",
    "noResults": "Tidak ada hasil untuk \"{{query}}\"",
    "noNotesTagged": "Tidak ada catatan dengan tag {{tag}}",
    "tagFilterAll": "Semua",
    "filterByTag_aria": "Filter berdasarkan tag",
    "templates": "Templat",
    "editorTheme_aria": "Tema editor",
    "themeActive_aria": "Tema {{theme}} (aktif)",
    "theme_aria": "Tema {{theme}}",
    "themeName": {
      "dark": "Gelap",
      "sepia": "Sepia",
      "light": "Terang",
      "forest": "Hutan"
    },
    "voice": "Suara",
    "voice_title": "Catatan suara",
    "voiceUnavailable_title": "Pengenalan suara tidak tersedia di peramban ini",
    "openVoiceRecorder_aria": "Buka perekam catatan suara",
    "summarizing_title": "Meringkas…",
    "summarize_title": "Ringkas",
    "summarizeNote_aria": "Ringkas catatan",
    "aiCommands_title": "Perintah AI  Cmd+K",
    "openAiPalette_aria": "Buka palet perintah AI",
    "enterFocusMode_title": "Mode fokus  Cmd+Shift+F",
    "exitFocusMode_title": "Keluar mode fokus  Cmd+Shift+F",
    "enterFocusMode_aria": "Masuk mode fokus",
    "exitFocusMode_aria": "Keluar mode fokus",
    "export_title": "Ekspor catatan",
    "delete_title": "Hapus catatan",
    "delete_aria": "Hapus catatan",
    "moreActions_title": "Tindakan lain",
    "wordCount_one": "{{formatted}} kata · ~{{minutes}} mnt baca",
    "wordCount_other": "{{formatted}} kata · ~{{minutes}} mnt baca",
    "referencedBy_one": "Dirujuk oleh {{count}}",
    "referencedBy_other": "Dirujuk oleh {{count}}",
    "noMatchingNotes": "Tidak ada catatan yang cocok",
    "mobileTabs_aria": "Tampilan catatan",
    "mobileTabNotes": "Catatan",
    "mobileTabEditor": "Editor",
    "saveFailed": "Gagal menyimpan catatan: {{message}}",
    "deleteFailed": "Gagal menghapus catatan",
    "loadFailed": "Gagal memuat catatan",
    "analyzeFailed": "Gagal menganalisis catatan",
    "aiCommandFailed": "Perintah AI gagal",
    "unknownError": "Galat tidak diketahui"
  },
  "paywall": {
    "title": "Catatan adalah bagian dari Rhemn Pro",
    "safariBody": "Buka catatan tersinkron, dikte, dan ringkasan AI dengan Rhemn Pro. Sudah menjadi anggota? Terbuka otomatis saat Anda masuk.",
    "body": "Buka catatan tersinkron, dikte berbasis peramban, dan ringkasan AI terstruktur."
  },
  "format": {
    "bold": "Tebal",
    "italic": "Miring",
    "strikethrough": "Coret",
    "inlineCode": "Kode sebaris",
    "heading1": "Judul 1",
    "heading2": "Judul 2",
    "heading3": "Judul 3",
    "bulletList": "Daftar berbutir",
    "numberedList": "Daftar bernomor",
    "blockquote": "Kutipan blok",
    "codeBlock": "Blok kode",
    "toggleBold_aria": "Alihkan tebal",
    "toggleItalic_aria": "Alihkan miring",
    "toggleStrikethrough_aria": "Alihkan coret",
    "toggleInlineCode_aria": "Alihkan kode sebaris",
    "toggleBulletList_aria": "Alihkan daftar berbutir",
    "toggleNumberedList_aria": "Alihkan daftar bernomor",
    "toggleBlockquote_aria": "Alihkan kutipan blok",
    "formatOptions_aria": "Opsi format"
  },
  "analysis": {
    "heading": "Ringkasan",
    "onDevice": "⚡ Di perangkat",
    "onDevice_aria": "Diproses di perangkat",
    "applyToNote_title": "Terapkan ke catatan",
    "applyToNote_aria": "Terapkan ringkasan ke catatan",
    "summaryLabel": "Ringkasan",
    "keyPointsLabel": "Poin Utama",
    "noKeyPoints": "Tidak ada poin utama yang dihasilkan untuk catatan ini."
  },
  "export": {
    "markdown": "Ekspor sebagai Markdown",
    "plainText": "Ekspor sebagai Teks Biasa",
    "pdf": "Ekspor sebagai PDF",
    "allZip": "Ekspor semua sebagai ZIP",
    "label": "Ekspor"
  },
  "cmdk": {
    "dialog_aria": "Palet perintah AI",
    "input_placeholder": "Tanya AI atau jalankan perintah…",
    "esc": "Esc",
    "back_aria": "Kembali",
    "translateTo": "Terjemahkan ke",
    "language_placeholder": "Bahasa…",
    "aiActions": "Tindakan AI",
    "noCommandsMatch": "Tidak ada perintah yang cocok dengan \"{{query}}\"",
    "continue": {
      "label": "Lanjutkan menulis",
      "description": "Lanjutkan dari tempat Anda berhenti"
    },
    "summarize": {
      "label": "Ringkas pilihan",
      "description": "Padatkan menjadi poin-poin utama"
    },
    "formal": {
      "label": "Buat ini formal",
      "description": "Tingkatkan nada menjadi profesional"
    },
    "simplify": {
      "label": "Sederhanakan",
      "description": "Bahasa lebih singkat dan jelas"
    },
    "translate": {
      "label": "Terjemahkan ke…",
      "description": "Terjemahkan ke bahasa lain"
    },
    "expand": {
      "label": "Kembangkan butir ini",
      "description": "Kembangkan butir terpilih menjadi prosa"
    },
    "languages": {
      "Spanish": "Spanyol",
      "Arabic": "Arab",
      "French": "Prancis",
      "German": "Jerman",
      "Japanese": "Jepang",
      "Portuguese": "Portugis"
    }
  },
  "templates": {
    "dialog_aria": "Pilih templat",
    "header": "Pilih Templat",
    "builtInLabel": "Bawaan",
    "myTemplatesLabel": "Templat Saya",
    "saveCurrent": "Simpan catatan saat ini sebagai templat",
    "myTemplatesEmpty": "Templat yang Anda simpan akan muncul di sini",
    "useTemplate": "Gunakan Templat",
    "meeting": {
      "name": "Catatan Rapat",
      "description": "Catat keputusan dan item tindakan",
      "structure": "Peserta / Agenda / Catatan / Tindakan"
    },
    "journal": {
      "name": "Jurnal Harian",
      "description": "Renungkan hari Anda",
      "structure": "Rasa syukur / Pencapaian hari ini / Catatan"
    },
    "book": {
      "name": "Ringkasan Buku",
      "description": "Catat gagasan utama dari sebuah buku",
      "structure": "Gagasan inti / Kutipan utama / Pelajaran"
    },
    "project": {
      "name": "Ringkasan Proyek",
      "description": "Uraikan ruang lingkup, tujuan, dan pemangku kepentingan",
      "structure": "Tujuan / Ruang lingkup / Risiko / Lini masa"
    },
    "brainstorm": {
      "name": "Curah Gagasan",
      "description": "Penangkapan ide bebas",
      "structure": "Topik / Ide / Langkah berikutnya"
    },
    "weekly": {
      "name": "Tinjauan Mingguan",
      "description": "Tinjau dan rencanakan minggu Anda",
      "structure": "Pencapaian / Tantangan / Area fokus"
    }
  },
  "voice": {
    "dialog_aria": "Perekam catatan suara",
    "cancel_aria": "Batal",
    "statusRecording": "Merekam",
    "statusTranscribing": "Mentranskripsi…",
    "statusReview": "Tinjau",
    "skip": "Lewati",
    "mark": "Tandai",
    "mark_title": "Jatuhkan penanda stempel waktu",
    "captureMeeting": "Tangkap rapat",
    "captureMeeting_title": "Tangkap juga audio dari tab rapat",
    "meeting": "Rapat",
    "meeting_title": "Menangkap tab rapat",
    "markers_aria": "Penanda stempel waktu",
    "listening": "Mendengarkan…",
    "micDenied": "Akses mikrofon nonaktif. Izinkan di Pengaturan, lalu coba lagi.",
    "captureFailed": "Perekaman tidak dapat dimulai. Coba lagi sebentar lagi.",
    "tabPicker_aria": "Pilih tab rapat untuk ditangkap",
    "captureFrom": "Tangkap audio dari…",
    "noAudibleTab": "Tidak ada tab yang memutar audio. Buka rapat Anda dan pastikan ada yang berbicara, lalu coba lagi.",
    "tabPickerCancel": "Batal",
    "tabTranscript": "Transkrip",
    "structuring": "Menyusun…",
    "structuredNote": "Catatan Terstruktur",
    "structureFailed": "Catatan terstruktur gagal dibuat.",
    "retryStructure": "Coba lagi",
    "browserTranscript": "Transkrip peramban",
    "nothingCaptured": "Tidak ada yang tertangkap.",
    "buildingStructured": "Membangun catatan terstruktur…",
    "cancel": "Batal",
    "stop": "Berhenti",
    "recordAgain": "Rekam lagi",
    "saveToNote": "Simpan ke Catatan",
    "statusMeeting": "Rapat",
    "captureStrip_aria": "Menangkap audio dari {{tab}}",
    "stopCapture": "Hentikan tangkapan",
    "stopCapture_title": "Berhenti menangkap tab — mikrofon tetap merekam",
    "stopsIn": "Berhenti dalam {{time}}",
    "autoStopped": "Rekaman berhenti di batas 60 menit.",
    "autoStoppedQuota": "Rekaman berhenti — menit transkripsi bulan ini telah habis.",
    "captureLost": "Tab rapat tertutup. Mikrofon Anda masih merekam.",
    "tabSummary": "Ringkasan",
    "noSpeakers": "Pembicara tidak teridentifikasi",
    "speakerN": "Pembicara {{number}}",
    "renameSpeaker_aria": "Ganti nama {{name}} — berlaku untuk semua barisnya",
    "renameSpeaker_input_aria": "Nama pembicara",
    "turnTime_title": "Diucapkan pada {{time}}",
    "actionItemsTitle": "Butir Tindakan",
    "actionsCount": "{{checked}} dari {{total}}",
    "addToTasks_other": "Tambahkan {{count}} ke Tugas",
    "addToTasksZero": "Tambahkan ke Tugas",
    "adding": "Menambahkan…",
    "tasksAdded_other": "{{count}} tugas ditambahkan",
    "viewTasks": "Lihat",
    "addFailed": "Gagal menambahkan — coba lagi.",
    "minutesLeft_other": "Sisa {{count}} mnt",
    "minutesLeftShort_other": "Sisa {{count}} mnt",
    "minutesLeft_title": "Sisa {{count}} menit transkripsi bulan ini",
    "quotaExhausted": "Menit rapat bulan ini telah habis. Diperbarui {{date}}.",
    "quotaUnknown": "Sisa menit tidak diketahui — rekaman bisa mencapai batas bulananmu",
    "meetingProRequired": "Transkripsi rapat adalah bagian dari Pro. Transkrip langsung Anda tersimpan di bawah.",
    "gateTitle": "Rekaman rapat",
    "gateBody": "Rekam tab rapat bersama mikrofon Anda — dengan pembicara teridentifikasi dan butir tindakan diekstrak. Termasuk dalam Pro.",
    "gateLater": "Nanti saja",
    "gateCta": "Lihat Pro",
    "roomOption": "Tanpa tab — rekam ruangan",
    "roomHint": "Panggilan di pengeras suara, aplikasi mandiri, atau orang di ruangan — apa pun yang bisa Anda dengar dengan jelas.",
    "roomHint_title": "Jika lawan bicara ada di headphone Anda, mikrofon tidak bisa mendengarnya — gunakan pengeras suara.",
    "recordRoom": "Rekam ruangan",
    "recordRoom_title": "Rekam semua yang terdengar mikrofon — dengan pembicara teridentifikasi",
    "roomStart": "Mulai",
    "statusRoom": "Ruangan",
    "roomStrip": "Merekam ruangan",
    "roomStrip_aria": "Merekam ruangan — semua yang terdengar mikrofon",
    "roomOff": "Matikan",
    "roomOff_title": "Matikan mode ruangan — ini menjadi catatan suara biasa",
    "roomRenameHint": "Ketuk sebuah nama untuk mengubahnya — salah satunya adalah Anda.",
    "gateBodyRoom": "Rekam apa yang dibicarakan di sekitar Anda — dengan pembicara teridentifikasi dan butir tindakan diekstrak. Termasuk dalam Pro.",
    "roomHintDevice": "Panggilan di perangkat ini tidak bisa direkam — iOS menjaganya tetap privat. Ponsel lain di pengeras suara, atau percakapan di ruangan, bisa.",
    "autoStoppedSize": "Rekaman berhenti di batas ukuran unggahan.",
    "tooLarge": "Rekaman terlalu besar untuk diunggah, jadi tidak bisa ditranskripsikan.",
    "destTo": "Ke",
    "dest_aria": "Tambahkan ke daftar: {{name}}",
    "destMenu_aria": "Pilih daftar",
    "destNewPending_aria": "Daftar baru: {{name}}"
  },
  "meetingNotice": {
    "title": "Rapat, di catatan Anda",
    "body": "Rhemn kini dapat merekam tab rapat pilihan Anda — hanya saat Anda merekam catatan suara, dan hanya tab yang Anda pilih.",
    "factPrivacy": "Audio diproses untuk membuat transkrip Anda, lalu dibuang. Rekaman tidak pernah disimpan.",
    "factControl": "Tidak ada yang ditangkap sampai Anda menekan rekam dan memilih tab.",
    "cta": "Mengerti",
    "privacyLink": "Baca kebijakan privasi kami",
    "dialog_aria": "Tentang izin rekaman rapat baru"
  }
}
